import { useState } from "react";
import Image from "next/image";
import recommenderService from "@/features/Recommender/services";

export default function CopyButton() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(
        `https://agentsrikrung.com/member-register?u=${
          recommenderService.getId() ?? 1
        }`,
      );
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // แสดง tooltip 2 วินาที
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <div className="relative cursor-pointer">
      <button
        onClick={handleCopy}
        className="flex items-center justify-center text-white w-10 h-10 border-2 border-[#126d37] rounded-xl"
        name="copy-link"
        aria-label="คัดลอกลิงก์สมัครสมาชิก"
      >
        <Image
          src="/icons/share-outline.svg"
          alt="Line"
          width={22}
          height={22}
        />
      </button>
      {copied && (
        <div className="w-[75px] absolute top-8 left-1/2 -translate-x-1/2 bg-black text-white text-xs px-2 py-1 rounded shadow">
          คัดลอกแล้ว
        </div>
      )}
    </div>
  );
}
